import PicklistMetadata from "../PicklistMetadata";

// Non-static picklist used ONLY by the "Unique" validator on the Rule Revision Name
// field. The validator queries this EC where typeValue (= "Name") equals the entered value; any
// match means the name is already taken. The RuleRevision EC query is realm-scoped
// server-side, so uniqueness is enforced within the tenant. (A rule's revisions all share its
// Name, but the Unique validator only fires when the value CHANGES, so an unchanged edit is fine.)
class RuleRevisionNameUniquePicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "RuleRevisionNameUnique";
        this.static = false;
        this.enterpriseComponent = "RuleRevision";
        this.useRealm = false;
        this.searchSpecification = null;
        this.sortSpecification = null;
        this.typeField = "Name";
        this.typeValue = "Name";
        this.allowNoSelection = false;
    }
}

export default RuleRevisionNameUniquePicklistMetadata;
